import { Project } from '@bulthaup/api/db';
import { getProjectAmounts } from '@bulthaup/api/entities/budget';
import { Alert, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Decimal } from 'decimal.js';

import { trpc } from '../../../../../../services/trpc';
import { formatAmount } from '../../../../../../utils/format';

export function TotalAmountAlert({ project }: { project: Project }) {
  const { data: supplies } = trpc.projects.getSupplies.useQuery({
    projectId: project.id,
  });

  const { amounts } = getProjectAmounts(project);

  const totalAmount = Object.values(amounts).reduce(
    (acc, val) => acc.add(val),
    new Decimal(0),
  );

  const totalAmountFromSupplies =
    supplies?.reduce(
      (acc, supply) => acc.add(supply.unitSellingPrice ?? 0),
      new Decimal(0),
    ) ?? new Decimal(0);

  const diff = totalAmount.sub(totalAmountFromSupplies);
  const isDisplayed = diff.abs().greaterThan(0.01);

  return (
    isDisplayed && (
      <Alert
        variant="filled"
        color="red"
        title="Montant Total Meuble et Électro"
        icon={<IconAlertTriangle size={16} />}
      >
        <Text>
          Dans la fiche fournisseur le total meuble et électro présente une
          différence de : <strong>{formatAmount(Number(diff))}</strong>
        </Text>
      </Alert>
    )
  );
}
